import { useState, useContext, useEffect, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import Account from '../components/Account';
import "../styles/recharge.css";
import mtn from "../assets/mtn1.jpg";
import glo from "../assets/glo.jpg";
import airtel from "../assets/airtel.jpg";
import etisalat from "../assets/9mobile.jpg";
import { FaKey, FaArrowRight } from "react-icons/fa";

const RechargeCard = () => {
  const { generateRechargeCardPin } = useContext(AuthContext);
  const navigate = useNavigate();

  const [network, setNetwork] = useState("MTN");
  const [denomination, setDenomination] = useState("");
  const [quantity, setQuantity] = useState("");
  const [loading, setLoading] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [errors, setErrors] = useState({});
  const quantityRef = useRef();
  const denominationRef = useRef();
  const networkRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    const newErrors = {};

    if (!network) {
      newErrors.network = "Please select a network provider.";
    }

    if (!denomination) {
      newErrors.denomination = "Please select an amount.";
    }

    const qty = parseInt(quantity, 10);
    if (!quantity) {
      newErrors.quantity = "Please enter quantity.";
    } else if (isNaN(qty) || qty < 1) {
      newErrors.quantity = "Quantity must be at least 1.";
    } else if (qty > 10) {
      newErrors.quantity = "You cannot generate more than 10 pins at once.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      const firstErrorField = newErrors.network
        ? networkRef
        : newErrors.denomination
        ? denominationRef
        : quantityRef;

      setTimeout(() => {
        firstErrorField.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);

      return;
    }
    const totalCost = parseInt(denomination) * parseInt(quantity);

    navigate("/review", {
      state: {
        type: "recharge-card",
        details: {
          network: network.toUpperCase(),
          amount: denomination,
          quantity: qty,
          totalCost
        },
      },
    });
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Account />
      <div className="recharge-card shadow-md">
        <form onSubmit={handleSubmit} className="space-y-3">
          <div ref={networkRef}>
            <label className="network-label">Select Network Provider</label>
            {screenWidth >= 800 ? (
              <select
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                className="w-full border styled-select rounded"
              >
                <option value="">-- Select Network --</option>
                <option value="MTN">MTN</option>
                <option value="GLO">GLO</option>
                <option value="AIRTEL">AIRTEL</option>
                <option value="9MOBILE">9MOBILE</option>
              </select>
            ) : (
              <div className="network-options">
                {[{ id: "MTN", src: mtn }, { id: "GLO", src: glo }, { id: "AIRTEL", src: airtel }, { id: "9MOBILE", src: etisalat }].map(({ id, src }) => (
                  <img
                    key={id}
                    src={src}
                    alt={id}
                    onClick={() => setNetwork(id)}
                    className={`network-image ${network === id ? "selected" : ""}`}
                  />
                ))}
              </div>
            )}
            {errors.network && <div className="error-input">{errors.network}</div>}
          </div>

          <div ref={denominationRef}>
            <label className="network-label">Amount</label>
            <select
              value={denomination}
              onChange={(e) => setDenomination(e.target.value)}
              className="styled-select"
            >
              <option value="">Select Amount</option>
              <option value="100">₦100</option>
              <option value="200">₦200</option>
              <option value="500">₦500</option>
            </select>
            {errors.denomination && <div className="error-input">{errors.denomination}</div>}
          </div>

          <div ref={quantityRef}>
            <label className="network-label">Quantity</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={quantity}
              onChange={(e) => {
                const raw = e.target.value.replace(/\D/g, "");
                if (raw.length <= 2) {
                  setQuantity(raw);
                }
              }}
              className="w-full border rounded styled-input"
              placeholder="Enter quantity (max 10)"
            />
            {errors.quantity && <div className="error-input">{errors.quantity}</div>}
          </div>

          <button type="submit" className="bulk-btn" disabled={loading}>
            {loading ? "Generating..." : "Generate Pins"}
          </button>
        </form>

        <div className="mt-4">
          <Link to="/generated-pins" className="token-widget-link">
            <div className="token-widget-box">
              <span className="token-title">
                <FaKey className="token-icon" /> View All Generated Pins
              </span>
              <span className="token-arrow">
                <FaArrowRight />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RechargeCard;
